import type { DomainStatus, RedirectType } from "@/types";

export function StatusBadge({ status }: { status: DomainStatus }) {
  const active = status === "active";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${
        active ? "bg-accent-100 text-accent-800" : "bg-background-200 text-foreground-600"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${active ? "bg-accent-500" : "bg-foreground-400"}`} />
      {active ? "运行中" : "已暂停"}
    </span>
  );
}

const TYPE_LABEL: Record<RedirectType, string> = {
  "301": "301 永久",
  "302": "302 临时",
  mask: "隐藏跳转",
};

export function RedirectTypeBadge({ type }: { type: RedirectType }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
      <i className="ri-arrow-left-right-line text-sm" />
      {TYPE_LABEL[type]}
    </span>
  );
}

export { TYPE_LABEL };